import React from 'react';
interface SectionIntroProps {
  label: string;
  title: string;
  body?: string;
  tone?: 'light' | 'dark';
  className?: string;
}
export function SectionIntro({
  label,
  title,
  body,
  tone = 'light',
  className = ''
}: SectionIntroProps) {
  const dark = tone === 'dark';
  return <div className={`max-w-[760px] ${className}`} data-id="element-30" data-mp="dnco89mmew8q">
      <p className={`font-mono text-[12px] uppercase tracking-[0.16em] ${dark ? 'text-copper' : 'text-copperDeep'}`} data-id="element-31" data-mp="dm1jo7lcpkgk">{label}</p>
      <h2 className={`mt-4 font-display text-[32px] font-bold leading-[1.1] lg:text-[42px] ${dark ? 'text-ivory' : 'text-ink'}`} data-id="element-32" data-mp="3vvlkrg8oum81">{title}</h2>
      {body && <p className={`mt-5 text-[17px] leading-[1.7] lg:text-[18px] ${dark ? 'text-mist' : 'text-inkSoft'}`} data-id="element-33" data-mp="3lw3356g93cj5">{body}</p>}
    </div>;
}